'use client';

import {
  BaseDialogType,
  defaultDialogMap,
  DialogContentMap
} from '@ianesthesie-kit/redux';
import {
  AddDocumentDialog,
  NoAssignedQuestionnaireDialog,
  NoDocumentsDialog,
  PhoneVerificationDialog,
  PhoneVerificationDialogWithPrompt,
  TokenExpiredDialog,
  UpdatablePhoneVerificationDialog,
  InputDialog,
  CommChannelVerificationDialog,
  PendingPatientNotFoundDialog,
  PushNotificationDialog,
  RegistrationHospitalConfirmationDialog
} from '@/components/dialogs';
import { InvoicesDialog } from '@/components/dialogs/invoicesDialog';

enum AppSpecificDialogType {
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  NO_ASSIGNED_QUESTIONNAIRE_FOUND = 'NO_ASSIGNED_QUESTIONNAIRE_FOUND',
  NO_PENDING_PATIENT = 'NO_PENDING_PATIENT',
  NO_DOCUMENTS = 'NO_DOCUMENTS',
  PHONE_OTP_VERIFICATION = 'PHONE_OTP_VERIFICATION',
  PHONE_OTP_VERIFICATION_WITH_PROMPT = 'PHONE_OTP_VERIFICATION_WITH_PROMPT',
  PHONE_OTP_VERIFICATION_WITH_PHONE_UPDATE = 'PHONE_OTP_VERIFICATION_WITH_PHONE_UPDATE',
  ADD_DOCUMENT = 'ADD_DOCUMENT',
  INPUT = 'INPUT',
  TEL_INPUT = 'TEL_INPUT',
  COMM_CHANNEL_VERIFICATION = 'COMM_CHANNEL_VERIFICATION',
  INVOICES = 'INVOICES',
  PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS',
  REGISTRATION_HOSPITAL_CONFIRMATION = 'REGISTRATION_HOSPITAL_CONFIRMATION'
}

export type AppDialogType = AppSpecificDialogType | BaseDialogType;
export const AppDialogType = {
  ...BaseDialogType,
  ...AppSpecificDialogType
};

export const appDialogMap: DialogContentMap<
  AppSpecificDialogType & BaseDialogType
> = {
  ...defaultDialogMap,
  [AppSpecificDialogType.TOKEN_EXPIRED]: TokenExpiredDialog,
  [AppSpecificDialogType.NO_ASSIGNED_QUESTIONNAIRE_FOUND]:
    NoAssignedQuestionnaireDialog,
  [AppSpecificDialogType.NO_DOCUMENTS]: NoDocumentsDialog,
  [AppSpecificDialogType.PHONE_OTP_VERIFICATION]: PhoneVerificationDialog,
  [AppSpecificDialogType.PHONE_OTP_VERIFICATION_WITH_PROMPT]:
    PhoneVerificationDialogWithPrompt,
  [AppSpecificDialogType.PHONE_OTP_VERIFICATION_WITH_PHONE_UPDATE]:
    UpdatablePhoneVerificationDialog,
  [AppSpecificDialogType.ADD_DOCUMENT]: AddDocumentDialog,
  [AppSpecificDialogType.INPUT]: InputDialog,
  [AppSpecificDialogType.TEL_INPUT]: InputDialog,
  [AppSpecificDialogType.COMM_CHANNEL_VERIFICATION]:
    CommChannelVerificationDialog,
  [AppSpecificDialogType.INVOICES]: InvoicesDialog,
  [AppSpecificDialogType.NO_PENDING_PATIENT]: PendingPatientNotFoundDialog,
  [AppSpecificDialogType.PUSH_NOTIFICATIONS]: PushNotificationDialog,
  [AppSpecificDialogType.REGISTRATION_HOSPITAL_CONFIRMATION]:
    RegistrationHospitalConfirmationDialog
};
